<template>
  <el-dialog
    ref="dialog"
    v-dialogDrag
    :title="dialogTitle"
    :visible.sync="dialogVisible"
    class="data_list_dialog"
    width="1200px"
    :before-close="modalClose"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    append-to-body
    @open="handleOpen('dialog')"
  >
    <div class="container-box">
      <!-- 查询条件 -->
      <div
        ref="searchCondition"
        class="search-condition"
      >
        <el-row :gutter="10">
          <el-col style="width:60px;padding-left:10px;">
            <el-button
              type="text"
              style=""
            >
              查询条件：
            </el-button>
          </el-col>
          <el-col :span="4">
            <el-input
              v-model="tableList.tableQuery.search.schemeNo"
              placeholder="请输入方案编号"
              style="width:100%"
              clearable
              @keyup.enter.native="loadTableData"
            />
          </el-col>
          <el-col :span="4">
            <el-input
              v-model="tableList.tableQuery.search.schemeName"
              placeholder="请输入方案名称"
              style="width:100%"
              clearable
              @keyup.enter.native="loadTableData"
            />
          </el-col>
          <el-col :span="4">
            <el-input
              v-model="tableList.tableQuery.search.materialsName"
              placeholder="请输入物料名称"
              style="width:100%"
              clearable
              @keyup.enter.native="loadTableData"
            />
          </el-col>
          <el-col :span="5">
            <el-button
              type="primary"
              @click="searchData(tableList)"
            >
              查询
            </el-button>
          </el-col>
        </el-row>
      </div>
      <!-- 数据列表 -->
      <div class="table-wrap table-list-show">
        <custom-table
          :ref="tableList.tableKey"
          :table-key="tableList.tableKey"
          :data-obj="tableList"
          :table-columns="tableList.tableColumns"
          :table-data="tableList.tableData"
          :loading="tableList.tableLoading"
          :search-condition.sync="tableList.tableQuery"
          :table-custom-height="tableHeight"
          :is-paging="isPaging"
          is-index-field
          :data-total="tableList.tableDataTotal"
          :table-contextmenu="tableList.tableContextmenu"
          @reloadData="loadTableData(tableList)"
          @createBill="createBillFun(arguments)"
        />
      </div>
      <!-- 新增 修改-->
      <add-edit-dialog
        :event-type="'add'"
        :select-object="selectCheckObj"
        :dialog-title="dialogAddEditTitle"
        :dialog-visible.sync="dialogAddEditVisible"
        :master-table-key="tableList.tableKey"
        @reloadData="reloadMasterData()"
      />
    </div>
  </el-dialog>
</template>
<script>
// 自定义Table
import CustomTable from '@/components/CustomTable'
// 计算表格高度，搜索，获取数据Mixin
import dialogTableCustomMixin from '@/mixin/dialogTableCustomMixin'
// dialog 拖拽dialogDragMixin
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 新增 修改
import AddEditDialog from './addEditDialog'
import { loadCallBackPendingListDataApi } from '@/api/callBackBill'
export default {
  name: 'CallBackPendingList',
  components: { CustomTable, AddEditDialog },
  mixins: [dialogDragMixin, dialogTableCustomMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    themeColor: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      customerName: '',
      tableList: {
        initTableColumn: [], // Table初始化列
        tableColumns: [], // Table列
        tableKey: 'call_back_pending_master', // Table Key
        tableIndex: 0, // Table Index
        tableLoading: false, // Table加载状态
        tableData: [], // Table数据
        tableDataTotal: 0, // Table总数据条数
        // Table右键
        tableContextmenu: [
          {
            prop: 'add',
            label: '创建回访记录',
            method: 'createBill'
          }
        ],
        tableQuery: {
          page: 1, // 页数
          limit: 50, // 每页条数
          contextmenuWrap: [], // 右键筛选字段
          sort: { // 排序对象
            prop: '', // 排序字段
            order: '' // 排序类型 ascending升序 descending降序
          },
          search: {
            schemeNo: '',
            schemeName: '',
            materialsName: ''
          }
        }
      },
      isPaging: true,
      dialogAddEditTitle: '',
      dialogAddEditVisible: false,
      selectCheckObj: null
    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        this.multipleSelection = []
        this.tableList.initTableColumn = [
          { prop: 'rowNumber', label: '序号', width: 80 },
          { prop: 'provinceName', label: '省区', filterColumn: 'db.province_name', width: 80 },
          { prop: 'cityName', label: '城市', filterColumn: 'db.city_name', width: 80 },
          // { prop: 'countyName', label: '区县', filterColumn: 'db.county_name', width: 80 },
          { prop: 'storeName', label: '终端名称', filterColumn: 'db.store_name', width: 140 },
          { prop: 'ownerName', label: '联系人', filterColumn: 'db.owner_name', width: 110 },
          { prop: 'phone', label: '联系电话', filterColumn: 'db.phone', width: 120 },
          { prop: 'receiver', label: '物料使用人', filterColumn: 'db.receiver', width: 120 },
          { prop: 'visitDateStr', label: '发放时间', filterColumn: 'db.visit_date', width: 110 },
          { prop: 'materialsName', label: '发放物料', filterColumn: 'db.materials_name', width: 160 },
          { prop: 'unitName', label: '物料单位', filterColumn: 'db.unit_name', width: 110 },
          { prop: 'amount', label: '发放数量', filterColumn: 'db.amount', width: 110 }
        ]
        this.tableList.tableColumns = this.tableList.initTableColumn
        this.searchData(this.tableList)
      }
    }
  },
  methods: {
    // 请求数据
    requestData () {
      this.tableList.tableLoading = true
      this.tableList.tableQuery.sort.order = 'desc'
      let pageCondition = { condition: JSON.stringify(this.tableList.tableQuery) }
      loadCallBackPendingListDataApi(pageCondition).then(response => {
        this.tableList.tableLoading = false
        let data = response.data.data ? response.data.data : []
        this.handleData(this.tableList, data)
        this.tableList.tableDataTotal = response.data.recordsTotal
      }).catch()
    },
    // 关闭弹框
    modalClose () {
      this.$emit('update:dialogVisible', false) // 直接修改父组件的属性
    },
    // 刷新列表
    reloadMasterData () {
      this.$emit('reloadData')
      this.loadTableData(this.tableList)
    },
    // 创建记录
    createBillFun (args) {
      if (!args[0]) {
        this.$message({
          message: '请选择数据行',
          type: 'warning'
        })
        return
      }
      this.selectCheckObj = args[0]
      this.dialogAddEditVisible = !this.dialogAddEditVisible
      this.dialogAddEditTitle = '新增回访记录'
    }
  }
}
</script>
<style lang="scss"  scoped>
.table-wrap {
  margin-top: 5px;
}
</style>
